// eslint-disable
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const en_total = /** @type {(inputs: {}) => string} */ () => {
	return `Total`
};

const el_total = /** @type {(inputs: {}) => string} */ () => {
	return `Σύνολο`
};

const ru_total = /** @type {(inputs: {}) => string} */ () => {
	return `Итого`
};

const he_total = /** @type {(inputs: {}) => string} */ () => {
	return `סה״כ`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "el" | "ru" | "he" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const total = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.total(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("total", locale)
	if (locale === "en") return en_total(inputs)
	if (locale === "el") return el_total(inputs)
	if (locale === "ru") return ru_total(inputs)
	if (locale === "he") return he_total(inputs)
	return "total"
};